define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');

    var LPQueue = function (constructorData) {
        // This queue does not support different values with the same key
        var queue = []; // the items queue
        var queueContent = {}; // This is only for efficient lookup on the queue
        var queueKey;

        if (constructorData && constructorData.key) {
            queueKey = constructorData.key;
        }

        this.enqueue = function (item) {
            queue.push(item);
            addItemToQueueContent(item);
        };

        this.dequeue = function () {
            if (queue.length === 0) {
                return null;
            }
            var item = queue[0];
            return this.removeFromQueue(item, true);
        };

        this.removeFromQueue = function (item, firstInstanceOnly) {
            var removedItem = null;
            if (this.contains(item)) {
                var indexOfItem = getIndexOf(queue, item);
                if (indexOfItem != -1) { // item exist at least once
                    if (firstInstanceOnly) {
                        removedItem = queue.splice(indexOfItem, 1)[0];
                        indexOfItem = getIndexOf(queue, item);
                    } else {
                        var queueWithoutItem = [];
                        for (var i = 0; i < queue.length; i++) {
                            if (item != queue[i]) {
                                queueWithoutItem.push(queue[i]);
                            }
                        }
                        if (queueWithoutItem.length < queue.length) {
                            removedItem = item;
                        }
                        queue = queueWithoutItem;
                        indexOfItem = -1;
                    }
                    if (indexOfItem == -1) {
                        removeItemFromQueueContent(item);
                    }
                }
            }
            return removedItem;
        };

        this.peek = function () {
            return (queue.length > 0 ? queue[0] : null);
        };

        this.isEmpty = function () {
            return (queue.length === 0);
        };

        this.size = function () {
            return queue.length;
        };

        this.contains = function (item) {
            var key = queueKey ? item[queueKey] : item;
            return !!queueContent[key];
        };

        this.getItem = function (item) {
            var returnItem = null;
            if (this.contains(item)) {
                var key = queueKey ? item[queueKey] : item;
                returnItem = queueContent[key];
            }
            return returnItem;
        };

        function addItemToQueueContent(item) {
            var key = queueKey ? item[queueKey] : item;
            queueContent[key] = item;
        }

        function removeItemFromQueueContent(item) {
            var key = queueKey ? item[queueKey] : item;
            queueContent[key] = null;
            delete queueContent[key];
        }

        function getIndexOf(array, searchElement) {
            return lpUtils.getIndexOf(array, searchElement);
        }
    };


    return LPQueue;

});
